/* Balance Landing — vanilla JS, sin dependencias.
   Soporta múltiples instancias y recargas del Theme Editor. */
(function () {
  'use strict';
  if (window.BalanceLanding) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cleanups = {};

  function sectionKey(el) {
    var s = el.closest('[data-balance-section]');
    return s ? s.getAttribute('data-balance-section') : '_global';
  }
  function addCleanup(el, fn) {
    var key = sectionKey(el);
    (cleanups[key] = cleanups[key] || []).push(fn);
  }
  function once(el, name) {
    var attr = 'data-balance-init-' + name;
    if (el.hasAttribute(attr)) return false;
    el.setAttribute(attr, '');
    return true;
  }
  function all(root, sel) {
    var list = Array.prototype.slice.call(root.querySelectorAll(sel));
    if (root.matches && root.matches(sel)) list.unshift(root);
    return list;
  }
  function behavior() { return reduceMotion.matches ? 'auto' : 'smooth'; }
  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------------- Acordeones ---------------- */
  function toggleAcc(acc, force) {
    var open = typeof force === 'boolean' ? force : !acc.hasAttribute('data-open');
    if (open) acc.setAttribute('data-open', ''); else acc.removeAttribute('data-open');
    var btn = acc.querySelector('[data-acc-btn]');
    if (btn) btn.setAttribute('aria-expanded', String(open));
    var group = acc.closest('[data-acc-group="single"]');
    if (open && group) {
      all(group, '[data-balance-acc][data-open]').forEach(function (o) { if (o !== acc) toggleAcc(o, false); });
    }
  }
  function initAccordions(root) {
    all(root, '[data-balance-acc]').forEach(function (acc) {
      if (!once(acc, 'acc')) return;
      var btn = acc.querySelector('[data-acc-btn]');
      if (btn) btn.addEventListener('click', function () { toggleAcc(acc); });
    });
  }

  /* ---------------- Slider genérico ---------------- */
  function initSliders(root) {
    all(root, '[data-balance-slider]').forEach(function (slider) {
      if (!once(slider, 'slider')) return;
      var track = slider.querySelector('[data-slider-track]');
      if (!track) return;
      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');
      var dots = slider.querySelector('[data-slider-dots]');

      function slides() { return Array.prototype.slice.call(track.children); }
      function perView() {
        var v = parseFloat(getComputedStyle(slider).getPropertyValue('--pv'));
        return Math.max(1, Math.floor(v || 1));
      }
      function offsetOf(i) { var s = slides(); return s[i].offsetLeft - s[0].offsetLeft; }
      function current() {
        var s = slides(), x = track.scrollLeft, idx = 0, best = Infinity;
        for (var i = 0; i < s.length; i++) {
          var d = Math.abs(offsetOf(i) - x);
          if (d < best) { best = d; idx = i; }
        }
        return idx;
      }
      function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
      function goTo(i) {
        var s = slides();
        if (!s.length) return;
        i = Math.max(0, Math.min(i, s.length - 1));
        track.scrollTo({ left: offsetOf(i), behavior: behavior() });
      }
      function update() {
        var s = slides();
        if (!s.length) return;
        var pv = perView();
        var scrollable = track.scrollWidth > track.clientWidth + 2;
        if (scrollable) slider.removeAttribute('data-static'); else slider.setAttribute('data-static', '');
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = atEnd() && !slider.hasAttribute('data-loop');
        if (dots) {
          var pages = Math.ceil(s.length / pv);
          if (dots.children.length !== pages) {
            dots.innerHTML = '';
            for (var p = 0; p < pages; p++) {
              (function (page) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'balance-slider__dot';
                b.setAttribute('aria-label', (slider.getAttribute('data-dot-label') || 'Ir a la diapositiva') + ' ' + (page + 1));
                b.addEventListener('click', function () { goTo(page * perView()); });
                dots.appendChild(b);
              })(p);
            }
          }
          var active = atEnd() ? pages - 1 : Math.floor(current() / pv);
          Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', String(k === active)); });
        }
      }

      if (prev) prev.addEventListener('click', function () { goTo(current() - perView()); });
      if (next) next.addEventListener('click', function () {
        if (atEnd() && slider.hasAttribute('data-loop')) goTo(0); else goTo(current() + perView());
      });
      track.addEventListener('keydown', function (e) {
        if (e.target !== track) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      });
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });

      var ro = null;
      if ('ResizeObserver' in window) { ro = new ResizeObserver(update); ro.observe(track); }

      var ms = parseInt(slider.getAttribute('data-autoplay') || '0', 10);
      var timer = null, paused = false;
      if (ms > 0 && !reduceMotion.matches) {
        timer = setInterval(function () {
          if (paused || document.hidden) return;
          if (atEnd()) goTo(0); else goTo(current() + perView());
        }, ms);
        ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (ev) {
          slider.addEventListener(ev, function () { paused = true; }, { passive: true });
        });
        slider.addEventListener('mouseleave', function () { paused = false; });
        slider.addEventListener('focusout', function (e) { if (!slider.contains(e.relatedTarget)) paused = false; });
      }

      addCleanup(slider, function () { if (ro) ro.disconnect(); if (timer) clearInterval(timer); });
      slider._balanceGoTo = goTo;
      update();
    });
  }

  /* ---------------- Carrusel continuo ---------------- */
  function initMarquees(root) {
    all(root, '[data-balance-marquee]').forEach(function (mq) {
      if (!once(mq, 'mq')) return;
      var track = mq.querySelector('[data-marquee-track]');
      var group = track && track.querySelector('[data-marquee-group]');
      if (!group) return;
      var originals = Array.prototype.slice.call(group.children);
      if (!originals.length) return;

      function asClone(node) {
        node.removeAttribute('data-shopify-editor-block');
        Array.prototype.forEach.call(node.querySelectorAll('[data-shopify-editor-block]'), function (x) { x.removeAttribute('data-shopify-editor-block'); });
        node.setAttribute('aria-hidden', 'true');
        return node;
      }
      function build() {
        Array.prototype.slice.call(group.children).forEach(function (c) { if (originals.indexOf(c) === -1) group.removeChild(c); });
        Array.prototype.slice.call(track.children).forEach(function (c) { if (c !== group) track.removeChild(c); });
        var guard = 0;
        while (group.getBoundingClientRect().width < mq.clientWidth && guard < 20) {
          originals.forEach(function (o) { group.appendChild(asClone(o.cloneNode(true))); });
          guard++;
        }
        var copy = group.cloneNode(true);
        copy.removeAttribute('data-marquee-group');
        copy.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(copy.children, asClone);
        track.appendChild(copy);
        Array.prototype.forEach.call(mq.querySelectorAll('img'), function (img) { img.loading = 'eager'; });
        var speed = Math.max(1, parseFloat(mq.getAttribute('data-speed') || '40'));
        var distance = group.getBoundingClientRect().width;
        track.style.setProperty('--mq-dur', Math.max(4, distance / speed) + 's');
      }

      build();
      var width = mq.clientWidth;
      var ro = null;
      if ('ResizeObserver' in window) {
        ro = new ResizeObserver(function () {
          if (Math.abs(mq.clientWidth - width) > 2) { width = mq.clientWidth; build(); }
        });
        ro.observe(mq);
      }
      addCleanup(mq, function () { if (ro) ro.disconnect(); });
    });
  }

  /* ---------------- Galería ---------------- */
  function initGalleries(root) {
    all(root, '[data-balance-gallery]').forEach(function (g) {
      if (!once(g, 'gallery')) return;
      var track = g.querySelector('[data-gallery-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
      var prev = g.querySelector('[data-gallery-prev]');
      var next = g.querySelector('[data-gallery-next]');
      var active = 0;

      function setActive(i) {
        active = i;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
        slides.forEach(function (s, k) {
          if (k !== i) Array.prototype.forEach.call(s.querySelectorAll('video'), function (v) { v.pause(); });
        });
        var t = thumbs[i];
        var row = g.querySelector('[data-gallery-thumbs]');
        if (t && row) {
          var left = row.scrollLeft + (t.getBoundingClientRect().left - row.getBoundingClientRect().left) - (row.clientWidth - t.offsetWidth) / 2;
          row.scrollTo({ left: left, behavior: behavior() });
        }
      }
      function goTo(i) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: behavior() });
        setActive(i);
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      if (prev) prev.addEventListener('click', function () { goTo(active - 1); });
      if (next) next.addEventListener('click', function () { goTo(active + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
      });
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== active && slides[i]) setActive(i);
        });
      }, { passive: true });
      g._balanceGoTo = goTo;
    });
  }

  /* ---------------- Countdown ---------------- */
  function initCountdowns(root) {
    all(root, '[data-balance-countdown]').forEach(function (el) {
      if (!once(el, 'cd')) return;
      var out = el.querySelector('[data-cd-timer]');
      var mode = el.getAttribute('data-mode');
      if (!out || mode === 'static') return;
      var end;
      if (mode === 'rolling') {
        var hours = parseInt(el.getAttribute('data-hours') || '24', 10);
        var key = 'balance-cd-' + el.getAttribute('data-id');
        var stored = 0;
        try { stored = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
        if (!stored || stored < Date.now()) {
          stored = Date.now() + hours * 3600000;
          try { localStorage.setItem(key, String(stored)); } catch (e) {}
        }
        end = new Date(stored);
      } else {
        end = new Date(); end.setHours(23, 59, 59, 999);
      }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var d = end - Date.now();
        if (d <= 0) {
          if (mode === 'rolling') { d = 0; } else { end.setDate(end.getDate() + 1); d = end - Date.now(); }
        }
        var h = Math.floor(d / 3600000), m = Math.floor((d % 3600000) / 60000), s = Math.floor((d % 60000) / 1000);
        out.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      var t = setInterval(tick, 1000);
      addCleanup(el, function () { clearInterval(t); });
    });
  }

  /* ---------------- Fechas de envío ---------------- */
  function initShipping(root) {
    all(root, '[data-balance-ship]').forEach(function (el) {
      if (!once(el, 'ship')) return;
      var min = parseInt(el.getAttribute('data-min') || '0', 10);
      var max = parseInt(el.getAttribute('data-max') || '0', 10);
      var skip = el.getAttribute('data-skip-weekends') === 'true';
      function addDays(n) {
        var d = new Date(), added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          var w = d.getDay();
          if (skip && (w === 0 || w === 6)) continue;
          added++;
        }
        return d;
      }
      var fmt;
      try { fmt = new Intl.DateTimeFormat(el.getAttribute('data-locale') || 'es-AR', { weekday: 'short', day: 'numeric', month: 'short' }); }
      catch (e) { fmt = { format: function (d) { return d.toLocaleDateString(); } }; }
      Array.prototype.forEach.call(el.querySelectorAll('[data-ship-from]'), function (x) { x.textContent = fmt.format(addDays(min)); });
      Array.prototype.forEach.call(el.querySelectorAll('[data-ship-to]'), function (x) { x.textContent = fmt.format(addDays(max)); });
    });
  }

  /* ---------------- Reviews: ver más ---------------- */
  function initReviews(root) {
    all(root, '[data-balance-reviews]').forEach(function (r) {
      if (!once(r, 'reviews')) return;
      var btn = r.querySelector('[data-rv-more]');
      if (!btn) return;
      var step = parseInt(r.getAttribute('data-step') || '8', 10);
      btn.addEventListener('click', function () {
        var hidden = r.querySelectorAll('.balance-review.is-hidden');
        Array.prototype.slice.call(hidden, 0, step).forEach(function (h) { h.classList.remove('is-hidden'); });
        if (!r.querySelector('.balance-review.is-hidden')) btn.parentElement.hidden = true;
      });
    });
  }

  /* ---------------- Hero: packs + carrito ---------------- */
  function BalanceHero(el) {
    this.el = el;
    this.form = el.querySelector('[data-balance-form]');
    if (!this.form) return;
    this.idInput = this.form.querySelector('[data-balance-variant-input]');
    this.qtyInput = this.form.querySelector('[data-balance-qty-input]');
    this.planInput = this.form.querySelector('[data-balance-plan-input]');
    this.buttons = Array.prototype.slice.call(el.querySelectorAll('[data-balance-atc]'));
    this.error = el.querySelector('[data-balance-error]');
    this.sticky = el.querySelector('[data-balance-sticky]');
    this.sub = el.querySelector('[data-balance-sub-input]');
    this.variantSelect = el.querySelector('[data-balance-variant-select]');
    this.radios = Array.prototype.slice.call(el.querySelectorAll('[data-balance-bundle-input]'));
    this.afterAdd = el.getAttribute('data-after-add') || 'cart';
    this.busy = false;
    this.current = null;

    var self = this;
    this.radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) self.selectBundle(r); });
    });
    if (this.variantSelect) this.variantSelect.addEventListener('change', function () { self.selectVariantOption(); });
    if (this.sub) this.sub.addEventListener('change', function () { self.updatePlan(); });
    this.form.addEventListener('submit', function (e) { self.submit(e); });

    if (this.sticky) {
      var stickyBtn = this.sticky.querySelector('[data-sticky-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (typeof self.form.requestSubmit === 'function') self.form.requestSubmit();
        else self.submit({ preventDefault: function () {} });
      });
      this.observeSticky();
    }

    var checked = this.radios.filter(function (r) { return r.checked; })[0] || this.radios[0];
    if (checked) { checked.checked = true; this.selectBundle(checked); }
    else if (this.variantSelect) this.selectVariantOption();
    else this.updatePlan();
  }

  BalanceHero.prototype.selectBundle = function (radio) {
    this.radios.forEach(function (r) {
      var card = r.closest('.balance-bundle');
      if (card) card.classList.toggle('is-selected', r === radio);
    });
    var d = radio.dataset;
    this.current = {
      id: d.variantId,
      qty: parseInt(d.qty, 10) || 1,
      price: d.priceText || '',
      compare: d.compareText || '',
      saving: d.savingText || '',
      available: d.available !== 'false',
      level: parseInt(d.level, 10) || 1,
      image: d.image || '',
      title: d.title || ''
    };
    this.apply();
  };

  BalanceHero.prototype.selectVariantOption = function () {
    var o = this.variantSelect.options[this.variantSelect.selectedIndex];
    if (!o) return;
    this.current = {
      id: o.value,
      qty: 1,
      price: o.getAttribute('data-price-text') || '',
      compare: o.getAttribute('data-compare-text') || '',
      saving: '',
      available: o.getAttribute('data-available') !== 'false',
      level: 1,
      image: o.getAttribute('data-image') || '',
      title: o.textContent.trim()
    };
    this.apply();
  };

  BalanceHero.prototype.apply = function () {
    var c = this.current;
    if (!c) return;
    if (this.idInput) this.idInput.value = c.id;
    if (this.qtyInput) this.qtyInput.value = c.qty;
    Array.prototype.forEach.call(this.el.querySelectorAll('[data-balance-price]'), function (x) { x.textContent = c.price; x.hidden = !c.price; });
    Array.prototype.forEach.call(this.el.querySelectorAll('[data-balance-compare]'), function (x) { x.textContent = c.compare; x.hidden = !c.compare; });
    Array.prototype.forEach.call(this.el.querySelectorAll('[data-balance-saving]'), function (x) { x.textContent = c.saving; x.hidden = !c.saving; });
    Array.prototype.forEach.call(this.el.querySelectorAll('.balance-gift'), function (g) {
      var need = parseInt(g.getAttribute('data-unlock') || '1', 10);
      var locked = c.level < need;
      g.classList.toggle('is-locked', locked);
      g.setAttribute('aria-disabled', String(locked));
    });
    this.renderButtons();
    if (this.sticky) {
      var img = this.sticky.querySelector('[data-sticky-img]');
      if (img && c.image) img.src = c.image;
      var t = this.sticky.querySelector('[data-sticky-title]');
      if (t && t.hasAttribute('data-show-bundle') && c.title) t.textContent = t.getAttribute('data-base') + ' · ' + c.title;
    }
    this.updatePlan();
    if (this.error) this.error.hidden = true;
  };

  BalanceHero.prototype.renderButtons = function (state) {
    var c = this.current || { available: true };
    this.buttons.forEach(function (b) {
      var label = b.querySelector('[data-atc-label]');
      var text = b.getAttribute('data-label-default');
      if (state === 'loading') text = b.getAttribute('data-label-loading');
      else if (state === 'added') text = b.getAttribute('data-label-added');
      else if (!c.available) text = b.getAttribute('data-label-soldout');
      if (label && text) label.textContent = text;
      b.classList.toggle('is-loading', state === 'loading');
      b.setAttribute('aria-busy', String(state === 'loading'));
      b.disabled = state === 'loading' || !c.available;
    });
  };

  BalanceHero.prototype.updatePlan = function () {
    if (!this.planInput) return;
    var on = !!(this.sub && this.sub.checked);
    this.planInput.disabled = !on;
    this.planInput.value = on ? (this.sub.getAttribute('data-plan') || '') : '';
  };

  BalanceHero.prototype.giftItems = function () {
    return Array.prototype.slice.call(this.el.querySelectorAll('.balance-gift[data-gift-variant]'))
      .filter(function (g) { return !g.classList.contains('is-locked') && g.getAttribute('data-gift-variant'); })
      .map(function (g) {
        return { id: parseInt(g.getAttribute('data-gift-variant'), 10), quantity: 1, properties: { _regalo: 'Sí' } };
      });
  };

  BalanceHero.prototype.submit = function (e) {
    e.preventDefault();
    if (this.busy) return;
    var self = this;
    var id = parseInt((this.current && this.current.id) || (this.idInput && this.idInput.value), 10);
    var qty = (this.current && this.current.qty) || parseInt((this.qtyInput && this.qtyInput.value) || '1', 10);
    if (!id) return;
    var item = { id: id, quantity: qty };
    if (this.planInput && !this.planInput.disabled && this.planInput.value) item.selling_plan = parseInt(this.planInput.value, 10);
    var items = [item].concat(this.giftItems());

    this.busy = true;
    this.renderButtons('loading');
    if (this.error) this.error.hidden = true;

    fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || '');
          return data;
        });
      })
      .then(function () { self.afterSuccess(); })
      .catch(function (err) {
        self.busy = false;
        self.renderButtons();
        self.showError((err && err.message) || self.el.getAttribute('data-error-text'));
      });
  };

  BalanceHero.prototype.afterSuccess = function () {
    var self = this;
    if (this.afterAdd === 'checkout') { window.location.href = routesRoot() + 'checkout'; return; }
    if (this.afterAdd === 'stay') {
      this.busy = false;
      this.renderButtons('added');
      document.dispatchEvent(new CustomEvent('balance:cart-added', { bubbles: true }));
      setTimeout(function () { self.renderButtons(); }, 2200);
      return;
    }
    window.location.href = routesRoot() + 'cart';
  };

  BalanceHero.prototype.showError = function (msg) {
    msg = msg || this.el.getAttribute('data-error-text') || 'Error';
    if (!this.error) { window.alert(msg); return; }
    this.error.textContent = msg;
    this.error.hidden = false;
  };

  BalanceHero.prototype.observeSticky = function () {
    var self = this;
    var main = this.el.querySelector('[data-balance-atc-main]');
    if (!main || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-visible', past);
        self.sticky.setAttribute('aria-hidden', String(!past));
        if ('inert' in self.sticky) self.sticky.inert = !past;
      });
    });
    io.observe(main);
    addCleanup(this.el, function () { io.disconnect(); });
  };

  function initHero(root) {
    all(root, '[data-balance-hero]').forEach(function (hero) {
      if (!once(hero, 'hero')) return;
      new BalanceHero(hero);
    });
  }

  /* ---------------- Init + Theme Editor ---------------- */
  function initAll(root) {
    root = root || document;
    initAccordions(root);
    initSliders(root);
    initMarquees(root);
    initGalleries(root);
    initCountdowns(root);
    initShipping(root);
    initReviews(root);
    initHero(root);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-balance-section]'), function (s) {
      var key = s.getAttribute('data-balance-section');
      (cleanups[key] || []).forEach(function (fn) { try { fn(); } catch (err) {} });
      delete cleanups[key];
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (!b || !b.closest) return;
    if (b.matches('[data-balance-acc]')) toggleAcc(b, true);
    var slide = b.closest('[data-slider-track] > *');
    if (slide) {
      var slider = slide.closest('[data-balance-slider]');
      var idx = Array.prototype.indexOf.call(slide.parentElement.children, slide);
      if (slider && slider._balanceGoTo) slider._balanceGoTo(idx);
    }
    var gs = b.closest('[data-gallery-track] > *');
    if (gs) {
      var g = gs.closest('[data-balance-gallery]');
      var gi = Array.prototype.indexOf.call(gs.parentElement.children, gs);
      if (g && g._balanceGoTo) g._balanceGoTo(gi);
    }
    var review = b.closest('.balance-review.is-hidden');
    if (review) review.classList.remove('is-hidden');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  window.BalanceLanding = { init: initAll };
})();
